































































import { computed, defineComponent, ref } from '@vue/composition-api';
import type { PropType } from '@vue/composition-api';

import type { Driver } from '@/useDeliveryNote';
import type { Vehicle } from '@/useVehicle';
import useAuth from '@/useAuth';
import useDeliveryAreaCode from '@/useDeliveryAreaCode';
import useDriverProfile from '@/useDriverProfile';

import WorkingLogsDisplay from '@/components/Driver/WorkingLogsDisplay.vue';
import CommonModalWithDriverSelector from '@/components/DeliveryNote/CommonModalWithDriverSelector.vue';
import CommonModalWithVehicleSelector from '@/components/DeliveryNote/CommonModalWithVehicleSelector.vue';

const ResourceSelectorInput = defineComponent({
  components: {
    WorkingLogsDisplay,
    CommonModalWithDriverSelector,
    CommonModalWithVehicleSelector,
  },
  props: {
    value: {
      type: Object as PropType<{ vehicle: Vehicle | undefined; driver: Driver | undefined }>,
      default: () => ({
        vehicle: undefined,
        driver: undefined,
      }),
    },
    variables: { default: () => ({}) },
    selectOnlyVehicle: { type: Boolean, default: false },
    enableFilterReservedOnly: { type: Boolean, default: true },
  },
  setup(props, { emit }) {
    const { me } = useAuth();
    const { distanceTypeToColor, possibleDistanceType } = useDeliveryAreaCode();
    const { mapLastSevenDaysDeliveryNotes } = useDriverProfile();
    const vehicleSelectorModal = ref(null);
    const driverSelectorModal = ref(null);
    function pendingSelectDriver() {
      (vehicleSelectorModal.value as any).open();
    }
    function setDriver(driver: any) {
      emit('input', {
        ...props.value,
        driver,
        vehicle: props.value.vehicle,
      });
    }
    function pendingSelectVehicle() {
      (driverSelectorModal.value as any).open();
    }
    function setVehicleOnDeliveryNote(vehicle: any) {
      const result = {
        ...props.value,
        vehicle,
        driver: undefined,
      };
      if (!(props.value.driver) && (props.value.driver as any)?.id !== -1) {
        emit('input', { ...result, driver: vehicle.defaultDriver });
      } else {
        emit('input', result);
      }
    }

    const computedVariables = computed(() => ({
      ...props.variables,
    }));

    return {
      me,
      driverSelectorModal,
      vehicleSelectorModal,
      pendingSelectDriver,
      pendingSelectVehicle,
      computedVariables,

      setDriver,
      setVehicleOnDeliveryNote,

      distanceTypeToColor,
      possibleDistanceType,
      mapLastSevenDaysDeliveryNotes,
    };
  },
});

export default ResourceSelectorInput;
